import React, { useState, useEffect, useCallback } from 'react';

interface CountdownProps {
  targetDate: string;
}

const Countdown: React.FC<CountdownProps> = ({ targetDate }) => {
  // Hesaplama fonksiyonunu useCallback ile sarmalayarak gereksiz yeniden üretimleri engelliyoruz
  const calculateTimeLeft = useCallback(() => {
    const difference = +new Date(targetDate) - +new Date();

    if (difference <= 0) {
      return {
        timeLeft: { gün: 0, saat: 0, dk: 0, sn: 0 },
        difference: 0
      };
    }

    return {
      timeLeft: {
        gün: Math.floor(difference / (1000 * 60 * 60 * 24)),
        saat: Math.floor((difference / (1000 * 60 * 60)) % 24),
        dk: Math.floor((difference / 1000 / 60) % 60),
        sn: Math.floor((difference / 1000) % 60),
      },
      difference
    };
  }, [targetDate]);

  const [timeData, setTimeData] = useState(calculateTimeLeft());

  useEffect(() => {
    // Her saniye güncelleme yapacak interval
    const timer = setInterval(() => {
      const updated = calculateTimeLeft();
      setTimeData(updated);

      if (updated.difference <= 0) {
        clearInterval(timer);
      }
    }, 1000);

    // Bileşen kapandığında (unmount) zamanlayıcıyı temizle
    return () => clearInterval(timer);
  }, [calculateTimeLeft]);

  const { timeLeft, difference } = timeData;

  if (difference <= 0) {
    return (
      <div className="mt-3 text-[10px] font-bold text-gray-400 bg-gray-50 border border-gray-100 px-3 py-1.5 rounded-full inline-block">
        Kampanya Sona Erdi
      </div>
    );
  }

  return (
    <div className="mt-3 flex items-center justify-center gap-2 text-[12px] font-semibold text-rose-600 bg-rose-50 border border-rose-100 px-4 py-1.5 rounded-full mx-auto w-fit shadow-sm">
      <span className="shrink-0">⌛ İndirim Bitişi:</span>
      <div className="flex gap-1 tracking-wide">
        {timeLeft.gün > 0 && <span className="tabular-nums">{timeLeft.gün}g</span>}
        <span className="tabular-nums">{timeLeft.saat}s</span>
        <span className="tabular-nums">{timeLeft.dk}dk</span>
        <span className="tabular-nums">{timeLeft.sn}sn</span>
      </div>
    </div>
  );
};

export default Countdown;